module.exports = __webpack_public_path__ + "img/3.fef9ca1b.png";